import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'initializers/types';

import { createReducers, createSelectors } from 'features/hiringV2/helpers';

import { INITIAL_APPLICATIONS_STATE } from './constants';
import { ApplicationsState } from './types';

const SLICE_NAME = 'applications';

const initialState = INITIAL_APPLICATIONS_STATE;

const applicationsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: createReducers(initialState),
});

const getApplicationsState = (state: RootState) =>
  state.get('hiringV2').applications as ApplicationsState;

// Selectors
export const selectApplications = createSelectors(
  getApplicationsState,
  initialState
);
export const applicationsActions = applicationsSlice.actions;

export const reducer = applicationsSlice.reducer;
